import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import cn from './styles.local.less';

export default class ExclusiveBadge extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  render() {
    const { className } = this.props;

    return (
      <div className={cns(cn.root, className)}>
        <span className={cn.rel}>{__('badge.exclusive')}</span>
      </div>
    );
  }
}
